import { computed, nextTick, onMounted, ref } from "vue";
import { fetchRss, type RssItem } from "./useRssFeed";

export const useTop = () => {
  const isAcdOpen = ref(false);
  const newsItems = ref<RssItem[]>([]);
  const caseItems = ref<RssItem[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  const latest = computed(() => newsItems.value.slice(0, 1));

  const load = async () => {
    loading.value = true;
    error.value = null;
    try {
      const [news, cases] = await Promise.all([
        fetchRss("https://note.bot-express.com/rss", 20),
        fetchRss("https://note.bot-express.com/m/m06f8498f3ab1/rss", 4),
      ]);
      newsItems.value = news;
      caseItems.value = cases;
      await nextTick();
      document.documentElement.classList.add("is-loaded");
      window.dispatchEvent(new Event("scroll"));
    } catch (e) {
      error.value = e instanceof Error ? e.message : "failed to load top rss";
      await nextTick();
      document.documentElement.classList.add("is-loaded");
    } finally {
      loading.value = false;
    }
  };

  const acdToggle = () => {
    isAcdOpen.value = !isAcdOpen.value;
  };

  onMounted(load);

  return {
    isAcdOpen,
    newsItems,
    caseItems,
    latest,
    loading,
    error,
    load,
    acdToggle,
  };
};
